import {CardHeader} from '../../../../../modules/components'
import {formatDoctorName, parseDate} from '../../../../../modules/utils'
import parseMoney from '../../../../../modules/utils/parseMoney'
import {DoctorInvoiceModel} from '../models'

interface Props {
    invoice: DoctorInvoiceModel
    isExport?: boolean
}
export default function InfoDoctorInvoiceSubpage({invoice, isExport = false}: Props) {
    return (
        <div className='card'>
            <CardHeader title='Informações gerais' goBack={!isExport} />
            <div className='card-body'>
                <div className='row mb-5'>
                    <div className='col-12 col-lg-3'>
                        <label>Data referência</label>
                        <h3>{invoice.reference_at}</h3>
                    </div>
                    <div className='col-12 col-lg-6'>
                        <label>Data referência</label>
                        <h3>{formatDoctorName(invoice.doctor)}</h3>
                    </div>
                    <div className='col-12 col-lg-3'>
                        <label>Documento</label>
                        <h3>{invoice.doctor.ds_cpf ?? invoice.doctor.ds_document ?? '-'}</h3>
                    </div>
                </div>
                <div className='row mb-5'>
                    <div className='col-12 col-lg-4'>
                        <label>Qtd. de consultas</label>
                        <h3>{invoice.consults_count}</h3>
                    </div>
                    <div className='col-12 col-lg-4'>
                        <label>Valor do profissional</label>
                        <h3
                            className={`text-${
                                invoice.status === 'PAID'
                                    ? 'success'
                                    : invoice.status === 'OPENED'
                                    ? 'info'
                                    : 'danger'
                            } m-0 me-2`}
                        >
                            {parseMoney(invoice.vn_doctor)}
                        </h3>
                    </div>
                    <div className='col-12 col-lg-4'>
                        <label>Status</label>
                        <h3
                            className={`text-${
                                invoice.status === 'PAID'
                                    ? 'success'
                                    : invoice.status === 'OPENED'
                                    ? 'info'
                                    : 'danger'
                            } m-0 me-2`}
                        >
                            {invoice.status === 'PAID'
                                ? 'Pago'
                                : invoice.status === 'OPENED'
                                ? 'Em aberto'
                                : 'Pendente'}
                        </h3>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 col-lg-4'>
                        <label>Data/Hora</label>
                        <h3>{parseDate(invoice.created_at) ?? invoice.created_at}</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}
